import React from 'react';
import PropTypes from 'prop-types';
import ColumnStep from 'components/column-step';
import {getColumnWidth, getColumnX, getStepY} from 'utils/layout-util';
import {isValid} from 'validators/number-validator';
import styles from './index.css';

export default class ColumnStepSeries extends React.Component {
  static propTypes = {
    columnSpacing: PropTypes.number,
    data: PropTypes.array,
    scaleY: PropTypes.func,
    style: PropTypes.object,
    tickWidth: PropTypes.number,
    transform: PropTypes.string,
  };

  static defaultProps = {
    columnSpacing: 2,
    data: [],
    scaleY: () => {},
    style: {},
    tickWidth: 0,
    transform: '',
  };

  render() {
    const {columnSpacing, data, scaleY, style, tickWidth, transform} =
      this.props;
    return (
      <g
        className={styles.ColumnStepSeries}
        style={style}
        transform={transform}>
        {data.map((datum, index) => {
          const width = getColumnWidth(tickWidth, columnSpacing);
          const x = getColumnX(tickWidth, index);
          const y = getStepY(scaleY, datum.value);
          return isValid(datum.value) ? (
            <ColumnStep
              className={datum.className}
              index={index}
              key={index}
              style={datum.style}
              width={width}
              x={x}
              y={y}
            />
          ) : null;
        })}
      </g>
    );
  }
}
